import React, { Component } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import BorderedButton from "components/General/Form/CustomButton/BorderedButton";
import "./GroupDetailTabs.css";
function GroupDetailTabs(props) {
  const options = props.options.map((option, index) => (
    <BorderedButton
      handleOnClick={() => props.handleOnClick(index)}
      buttonClassName={
        props.selectedTabIndex == index
          ? "background_dark_bright_blue"
          : "background_white"
      }
      borderColor="#30afc8"
      title={option}
      textClassName={
        props.selectedTabIndex == index
          ? "tab_label_text text_white"
          : "tab_label_text text_dark_bright_blue"
      }
    />
  ));
  return (
    <ButtonGroup size="lg" className="mb-15 tabbed_possible_friend">
      {options}
    </ButtonGroup>
  );
}

export default GroupDetailTabs;
